import type { DeliveryProfile } from '@/entities/sender.entity';
import { createDefaultDeliveryProfile } from '@/entities/sender.entity';
import { Label } from '@/components/ui/label';

interface SenderDeliveryProfileFormProps {
	value: DeliveryProfile;
	onChange: (next: DeliveryProfile) => void;
	disabled?: boolean;
}

export default function SenderDeliveryProfileForm({
	value,
	onChange,
	disabled = false,
}: SenderDeliveryProfileFormProps) {
	function patchAudience(patch: Partial<DeliveryProfile['audience']>) {
		onChange({
			...value,
			audience: { ...value.audience, ...patch },
		});
	}

	return (
		<div className='flex flex-col gap-4'>
			<div>
				<p className='text-sm font-medium'>Параметры доставки</p>
				<p className='text-xs text-muted-foreground'>
					Тайминги и batch задаются в коде:{' '}
					<code className='text-xs'>telegram-sender/src/sender/telegram/run_timing.py</code>{' '}
					(scheduling_window(n)=round(n×271/484), cleanup_budget(n)=round(n×110/484)). Изменяются
					только через деплой.
				</p>
			</div>

			<div className='flex flex-col gap-1.5 max-w-md'>
				<Label htmlFor='sender-audience-filter'>Аудитория</Label>
				<select
					id='sender-audience-filter'
					className='flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm'
					value={value.audience.filter ?? 'contacts_and_dialogs'}
					onChange={e =>
						patchAudience({
							filter: e.target.value as NonNullable<DeliveryProfile['audience']['filter']>,
						})
					}
					disabled={disabled}
				>
					<option value='mutual_only'>mutual_only</option>
					<option value='contacts_and_dialogs'>contacts_and_dialogs</option>
				</select>
			</div>
		</div>
	);
}

export function defaultAdminDeliveryProfile(): DeliveryProfile {
	return createDefaultDeliveryProfile();
}
